import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { KYMW7100Model } from "../kymw7100.model";
import { MediumTypeModel } from "../vo/medium-type.model";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";

export type GetBundleCatalogMediumResponse = {
  MediumType: string;
  MediumName: string;
}[];

/**
 * 媒体情報を取得するサービス
 *
 * @export GetBundleCatalogMediumService
 * @class GetBundleCatalogMediumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBundleCatalogMediumService extends PlessJsonResponderSub<GetBundleCatalogMediumResponse> {
  private model: KYMW7100Model;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBundleCatalogMediumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetBundleCatalogMediumService
   */
  execute(model: KYMW7100Model) {
    this.model = model;
    this.send('getBundleCatalogMedium', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetBundleCatalogMediumService 
   */
  success(data: GetBundleCatalogMediumResponse) {
    this.model.mediumTypeList = data.map(({ MediumType, MediumName }) => new MediumTypeModel(MediumType, `${MediumType}:${MediumName}`));
  }
} 